import React from "react";
import TerminalWithVoiceResponse from "./TerminalWithVoiceResponse";

const App = () => {
    return (
        <div>
            <TerminalWithVoiceResponse></TerminalWithVoiceResponse>
        </div>
    );
};

export default App;

